// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M8 1.5C11.49 1.5 14.34 4.25 14.49 7.7C14.5 7.8 14.5 7.9 14.5 8C14.5 11.59 11.59 14.5 8 14.5M8 14.5C4.41 14.5 1.5 11.59 1.5 8C1.5 7.89 1.49 7.8 1.5 7.7M8 14.5C9.53 14.5 10.77 11.59 10.77 8C10.77 4.41 9.53 1.5 8 1.5M8 14.5C6.47 14.5 5.23 11.59 5.23 8C5.23 4.41 6.47 1.5 8 1.5M8 1.5C4.52 1.5 1.66 4.26 1.5 7.7M1.5 7.7C5.69 9.29 10.31 9.29 14.49 7.7',
];
